import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTimes, faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";
import {
  saveAttribute,
  getListAttributes,
  getListValues,
  removeAttribute,
  removeValue,
  saveListValues,
} from "../../../../services/listService";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../../config';
import * as Icon from "react-feather";
import CustomLoader from "../../../common/Loader";
import { Link } from "react-router-dom";
import { Dialog, DialogTitle, DialogActions } from "@material-ui/core";
import { logActivity } from '../../../../services/utilService';

class ListSettings extends Component {
  state = {
    Project_ID: this.props.location.Project_ID
      ? this.props.location.Project_ID
      : 0,
    List_ID: this.props.location.List_ID ? this.props.location.List_ID : 8,
    List_Name: this.props.location.List_Name
      ? this.props.location.List_Name
      : "",
    Attributes: [],
    List_Values: [],

    //front end use
    loading: false,
    showAttrModal: false,
    temp_attr: "",
  };

  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
  }

  async loadListValues() {
    this.setState({ loading: true });
    const { data: Attributes } = await getListAttributes(this.state.List_ID);
    this.setState({ Attributes });

    let { data: List_Values } = await getListValues(this.state.List_ID);
    List_Values.forEach((lv, lvIdx) => {
      lv.Attributes = JSON.parse(lv.Attributes);
      if (lv.Display_Order === null) lv.Display_Order = (lvIdx + 1); //To remove when all lists reworked
    });
    this.setState({ List_Values });
    this.setState({ loading: false });
  }

  componentDidMount() {
    this.loadListValues();
  }

  CheckApiError(data) {
    if (data.includes("Error")) {
      toaster('error', data);
      return true;
    }
    return false;
  }

  async handleSave() {
    const { data } = await saveListValues(
      this.state.List_ID,
      this.state.List_Values
    );
    if (data.includes("Error")) {
      toaster('error', data);
      logActivity('/projectSettings', 'PROJECT_LIST_SAVE_FAILED');
    } else {
      toaster('success', data);
      logActivity('/projectSettings', 'PROJECT_LIST_SAVE_SUCCESS');
    }
    let { data: List_Values } = await getListValues(this.state.List_ID);
    List_Values.forEach((lv) => {
      lv.Attributes = JSON.parse(lv.Attributes);
    });
    this.setState({ List_Values });
  }

  handleChange = ({ currentTarget: input }) => {
    this.setState({ [input.name]: input.value });
  };

  handleAttrAdd = async () => {
    if (!this.state.temp_attr) {
      toaster('error', 'Please enter attribute name.');
      return;
    }

    let attribute_id = 0;
    let { data } = await saveAttribute(
      attribute_id,
      this.state.temp_attr,
      this.state.List_ID
    );

    if (this.CheckApiError(data)) {
      return;
    }

    attribute_id = parseInt(data.split(":").pop());
    const Attributes = [
      ...this.state.Attributes,
      {
        Attribute_ID: attribute_id,
        Attribute_Name: this.state.temp_attr,
      },
    ];
    this.setState({ Attributes });

    let List_Values = [...this.state.List_Values];
    List_Values.forEach((lv) => {
      lv.Attributes.push({
        Record_ID: 0,
        List_Value_ID: lv.List_Value_ID,
        Attribute_ID: attribute_id,
        Attribute_Value: "",
      });
    });
    this.setState({ List_Values });
    this.setState({ temp_attr: "" });
  };

  handleAttrRemove = async (idx) => {
    const Attributes = [...this.state.Attributes];
    const aid = Attributes[idx].Attribute_ID;

    const { data } = await removeAttribute(this.state.List_ID, aid);
    if (this.CheckApiError(data)) {
      return;
    }

    Attributes.splice(idx, 1);
    let List_Values = [...this.state.List_Values];
    List_Values.forEach((lv) => {
      lv.Attributes = lv.Attributes.filter((attr) => attr.Attribute_ID !== aid);
    });

    this.setState({ List_Values });
    this.setState({ Attributes });
  };

  handleValueAdd = () => {
    let value_attributes = [];
    this.state.Attributes.forEach(function (attr) {
      value_attributes.push({
        Record_ID: 0,
        List_Value_ID: 0,
        Attribute_ID: attr.Attribute_ID,
        Attribute_Value: "",
      });
    });

    let new_Value_ID = Math.max.apply(null, (this.state.List_Values).map(l => {
      return parseInt(l.Value_ID);
    })) + 1;
    new_Value_ID = (new_Value_ID <= 0) ? 1 : new_Value_ID;
    let new_value = {
      List_Value_ID: this.state.List_Values.length > 0 ? -this.state.List_Values.at(-1).Display_Order - 1 : -1,
      Value_Text: "",
      Value_ID: new_Value_ID.toString(),
      Attributes: value_attributes,
      Display_Order: this.state.List_Values.length > 0 ? this.state.List_Values.at(-1).Display_Order + 1 : 1,
    };

    const List_Values = [...this.state.List_Values, new_value];
    this.setState({ List_Values });
  };

  handleValueRemove = async (List_Value_ID) => {
    const { data } = await removeValue(List_Value_ID);
    if (this.CheckApiError(data)) {
      return;
    }
    toaster('success', data);

    const List_Values = this.state.List_Values.filter(
      (lv) => lv.List_Value_ID !== List_Value_ID
    );
    this.setState({ List_Values });
  };

  handleValueChange = (target, List_Value_ID) => {
    const List_Values = [...this.state.List_Values];
    List_Values.map((list)=>{
      if(list.List_Value_ID === List_Value_ID){
        list[target.name] = target.value;
      }
      return list;
    })
    this.setState({ List_Values });
  };

  handleValueAttrChange = (List_Value_ID, attrIdx, text) => {
    const List_Values = [...this.state.List_Values];
    List_Values.map((list)=>{
      if(list.List_Value_ID === List_Value_ID){
        list["Attributes"][attrIdx]["Attribute_Value"] = text;
      }
      return list;
    })
    this.setState({ List_Values });
  };

  handleClose = () => {
    this.setState({ showAttrModal: false });
  };

  handleShow = () => {
    this.setState({ showAttrModal: true });
  };

  handleMove = (idx, direction) => {
    const list = this.state.List_Values[idx], currentDO = list['Display_Order'];
    const List_Values = this.state.List_Values.filter((lv) => lv.Value_ID !== list.Value_ID);
    list['Display_Order'] = List_Values[idx + direction]['Display_Order'];
    List_Values[idx + direction]['Display_Order'] = currentDO;
    List_Values.splice(idx + direction, 0, list);
    this.setState({ List_Values });
  };

  render() {
    if (this.state.loading) {
      return <CustomLoader loading={this.state.loading} />;
    }

    const { List_ID, List_Name, Project_ID } = this.state;
    let { Attributes, List_Values } = this.state;
    return (
      <React.Fragment>
        <header className="page-header page-header-dark bg-gradient-primary-to-secondary pb-10">
          <div className="container">
            <div className="page-header-content pt-4">
              <div className="row align-items-center justify-content-between">
                <div className="col-auto mt-4">
                  <h1 className="page-header-title">
                    <div className="page-header-icon">
                      <Icon.Tool />
                    </div>
                    List Settings
                  </h1>
                </div>
                <div className='col-12 col-xl-auto mt-4'>List ID: {List_ID}</div>
              </div>
              <ol className="breadcrumb mb-0 mt-4">
                <li className="breadcrumb-item">
                  <Link
                    to={{
                      pathname: "/projects/",
                    }}
                  >
                    Projects
                  </Link>
                </li>
                <li className="breadcrumb-item">
                  <Link
                    to={{
                      pathname: "/projectSettings/",
                      Project_ID: Project_ID,
                    }}
                  >
                    Project
                  </Link>
                </li>
                <li className="breadcrumb-item active">{List_Name}</li>
              </ol>
            </div>
          </div>
        </header>

        <div className="container mt-n10">
          <div className="card mb-4">
            <div className="card-body">
              <div className="float-right">
                <button
                  className="btn btn-outline-purple rounded-0"
                  onClick={this.handleShow}
                >
                  Attributes
                </button>
                <Dialog
                  onClose={this.handleClose}
                  maxWidth="sm"
                  fullWidth
                  open={this.state.showAttrModal}
                  aria-labelledby="attributesDialog"
                >
                  <DialogTitle id="attributesDialog">
                    {List_Name} Attributes
                  </DialogTitle>
                  <div className="list-group list-group-flush">
                    {Attributes.map((attr, idx) => {
                      return (
                        <li
                          className="list-group-item"
                          key={"attrRemove" + idx}
                        >
                          {attr.Attribute_Name}
                          <div className="float-right">
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => this.handleAttrRemove(idx)}
                            >
                              <FontAwesomeIcon icon={faTimes} />
                            </button>
                          </div>
                        </li>
                      );
                    })}
                    <li className="list-group-item text-center" key={-1}>
                      <div className="input-group">
                        <input
                          className="form-control"
                          name="temp_attr"
                          value={this.state.temp_attr}
                          onChange={this.handleChange}
                        />
                        <div className="input-group-append">
                          <button
                            className="btn btn-success btn-sm"
                            onClick={this.handleAttrAdd}
                          >
                            <FontAwesomeIcon icon={faPlus} />
                          </button>
                        </div>
                      </div>
                    </li>
                    <hr className="mt-0 mb-2" />
                  </div>
                  <DialogActions>
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={this.handleClose}
                    >
                      Done
                    </button>
                  </DialogActions>
                </Dialog>
              </div>
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>List Value Text</th>
                    <th>List Value Code</th>
                    {Attributes.map((row, idx) => {
                      return (
                        <th scope="col" key={"attrName" + idx}>
                          <div className="input-group">
                            {row.Attribute_Name}
                          </div>
                        </th>
                      );
                    })}
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {List_Values.sort((a, b) => a.Display_Order > b.Display_Order ? 1 : -1).map((list_value, idx) => {
                    return (
                      <tr key={"listVal" + idx}>
                        <th scopr="row">
                          <input
                            type="text"
                            className="form-control"
                            name="Value_Text"
                            value={list_value.Value_Text}
                            onChange={(e) =>
                              this.handleValueChange(e.target, list_value.List_Value_ID)
                            }
                          />
                        </th>
                        <th>
                          <input
                            type="text"
                            className="form-control"
                            name="Value_ID"
                            value={list_value.Value_ID}
                            readOnly={'readOnly'}
                          />
                        </th>
                        {list_value.Attributes.map((value_attr, attrIdx) => {
                          return (
                            <th
                              key={
                                value_attr.Attribute_ID +
                                "-" +
                                value_attr.Record_ID
                              }
                            >
                              <input
                                type="text"
                                className="form-control"
                                value={value_attr.Attribute_Value}
                                onChange={(e) =>
                                  this.handleValueAttrChange(
                                    list_value.List_Value_ID,
                                    attrIdx,
                                    e.currentTarget.value
                                  )
                                }
                              />
                            </th>
                          );
                        })}
                        <th>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() =>
                              this.handleValueRemove(list_value.List_Value_ID)
                            }
                          >
                            <FontAwesomeIcon icon={faTimes} />
                          </button>
                          {/* Reorder: Move Up */}
                          <button
                            className="btn btn-light btn-sm float-right"
                            onClick={() => idx === 0 ? undefined : (this.handleMove(idx, -1))}
                          >
                            <FontAwesomeIcon icon={faArrowUp} />
                          </button>
                          {/* Reorder: Move Down */}
                          <button
                            className="btn btn-light btn-sm float-right"
                            onClick={() => this.handleMove(idx, 0)}
                          >
                            <FontAwesomeIcon icon={faArrowDown} />
                          </button>
                        </th>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div className="text-center">
                <button
                  className="btn btn-success btn-sm"
                  onClick={this.handleValueAdd}
                >
                  <FontAwesomeIcon icon={faPlus} />
                </button>
              </div>
            </div>
            <div className="card-footer text-center">
              <button
                className="btn btn-outline-primary rounded-0"
                onClick={this.handleSave}
              >
                Save
              </button>
            </div>
          </div>
        </div>
        <ToastContainer/>
      </React.Fragment>
    );
  }
}

export default ListSettings;
